import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-scoreboard',
  templateUrl: './dashboard-scoreboard.component.html',
  styleUrls: ['./dashboard-scoreboard.component.css']
})
export class DashboardScoreboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/dashboard-scoreboard/dashboard-scoreboard.component.ts